import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { LocalStorageKey } from '@shared/constants/localStorageKey';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { MainQuery } from '@shared/store/main/main.query';

@Component({
  imports: [IconComponent, AsyncPipe],
  selector: 'aux-stage-banner',
  template: `
    <div
      class="flex items-center justify-between bg-aux-brown-beige px-8 py-4 text-sm font-semibold"
    >
      <div class="flex items-center">
        <aux-icon name="InfoCircle" />
        <span class="ml-2">Currently in {{ envName$ | async }} Environment</span>
      </div>
      <span
        data-pendo-id="pendo-sandbox-banner"
        class="flex cursor-pointer items-center"
        (click)="hideBanner()"
      >
        <aux-icon name="X"></aux-icon>
      </span>
    </div>
  `,
})
export class StageBannerComponent {
  private launchDarklyService = inject(LaunchDarklyService);
  private mainQuery = inject(MainQuery);

  envName$ = this.launchDarklyService.envName$;

  hideBanner() {
    this.mainQuery.setBannerWarningVisibility(false, LocalStorageKey.STAGE_BANNER);
  }
}
